export default __webpack_public_path__ + "static/media/ind5.8ca00e19.jpg";